import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { SharedPipesModule } from 'src/app/pipes/shared-pipes.module';
import { ComboModuloReunioesModule } from '../combo-modulo-reunioes/combo-modulo-reunioes.module';
import { ComboTipoReuniaoComponent } from './combo-tipo-reuniao.component';



@NgModule({
  declarations: [ComboTipoReuniaoComponent],
  imports: [
    CommonModule,
    MaterialCommonModule,
    SharedPipesModule,
    MatExpansionModule,
    ComboModuloReunioesModule
  ],
  exports:[ComboTipoReuniaoComponent]
})
export class ComboTipoReuniaoModule { }
